// extracted by mini-css-extract-plugin
export default {"table":"DataTable_table__kDARA","pointerTable":"DataTable_pointerTable__4w-HB","selectedRow":"DataTable_selectedRow__mcpbQ","canceledRow":"DataTable_canceledRow__1iJRf"};